var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loader',{style:(_vm.style),attrs:{"color":_vm.color,"size":"25px"}})}
var staticRenderFns = []

export { render, staticRenderFns }